import {
  SIGN_UP,
  SIGN_IN,
  SIGN_OUT,
  CONFIRM_SIGN_UP,
  COMPLETE_SIGN_UP,
  COMPLETE_SIGN_IN,
  COMPLETE_SIGN_OUT,
  COMPLETE_CONFIRM_SIGN_UP,
  RECEIVE_AUTH_ERROR,
  RESEND_CODE,
  COMPLETE_RESEND_CODE,
  SET_AUTH_EMAIL,
  REQUEST_PASSWORD_RESET,
  COMPLETE_REQUEST_PASSWORD_RESET,
  SUBMIT_FORGOT_PASSWORD,
  COMPLETE_SUBMIT_FORGOT_PASSWORD,
  CLEAR_AUTH_ERROR,
  CHANGE_PASSWORD,
  COMPLETE_CHANGE_PASSWORD,
  CHECK_CURRENT_USER,
  COMPLETE_CHECK_CURRENT_USER,
  REDIRECT,
  RECEIVE_CONTEST_AUTH_ERROR,
  CLEAR_CONTEST_AUTH_ERROR,
  RECEIVE_USERNAME
} from '../constants/actionTypes';

import {
  toggleActiveAuthPopUp,
  setSignupFlow,
  fetchContestItems,
  setContestStep,
  contestHasSubmitted
} from './contest';

import { USER_NOT_CONFIRMED } from '../constants';
import Cookies from 'universal-cookie';

import api, { apiAuth } from '../api';

import { Auth } from 'aws-amplify';

const preSignUpErrStr = 'PreSignUp failed with error';

export const signUp = () => ({
  type: SIGN_UP
});

export const completeSignUp = data => ({
  type: COMPLETE_SIGN_UP,
  data
});

export const signIn = () => ({
  type: SIGN_IN
});

export const completeSignIn = user => ({
  type: COMPLETE_SIGN_IN,
  user
});

export const signOut = () => ({
  type: SIGN_OUT
});

export const completeSignOut = () => ({
  type: COMPLETE_SIGN_OUT
});

export const receiveAuthError = error => {
  let errorObj = error;
  // Since too many password attemps also uses NotAuthorizedException, need to differentiate it here
  // Check message for errors that share error code but have different message
  if (errorObj.message) {
    if (errorObj.message === 'User is disabled') {
      errorObj = {
        ...error,
        code: 'UserDisabledException'
      };
    } else if (errorObj.message === 'Password attempts exceeded') {
      errorObj = {
        ...error,
        code: 'TooManySignInAttemptsException'
      };
    } else if (
      errorObj.message === `${preSignUpErrStr} Email already exists.`
    ) {
      errorObj = {
        ...error,
        code: 'UsernameExistsException'
      };
    }
  }
  return {
    type: RECEIVE_AUTH_ERROR,
    error: errorObj
  };
};

export const confirmSignUp = () => ({
  type: CONFIRM_SIGN_UP
});

export const completeConfirmSignUp = () => ({
  type: COMPLETE_CONFIRM_SIGN_UP
});

export const resendCode = () => ({
  type: RESEND_CODE
});

export const completeResendCode = () => ({
  type: COMPLETE_RESEND_CODE
});

export const requestPasswordReset = () => ({
  type: REQUEST_PASSWORD_RESET
});

export const completeRequestPasswordReset = () => ({
  type: COMPLETE_REQUEST_PASSWORD_RESET
});

export const changePassword = () => ({
  type: CHANGE_PASSWORD
});

export const completeChangePassword = () => ({
  type: COMPLETE_CHANGE_PASSWORD
});

export const submitForgotPassword = () => ({
  type: SUBMIT_FORGOT_PASSWORD
});

export const completeSubmitForgotPassword = () => ({
  type: COMPLETE_SUBMIT_FORGOT_PASSWORD
});

export const setAuthEmail = email => ({
  type: SET_AUTH_EMAIL,
  email
});

export const checkCurrentUser = () => ({
  type: CHECK_CURRENT_USER
});

export const completeCheckCurrentUser = user => ({
  type: COMPLETE_CHECK_CURRENT_USER,
  user
});

export const clearAuthError = () => ({
  type: CLEAR_AUTH_ERROR
});

export const redirect = () => ({
  type: REDIRECT
});

export const receiveUsername = userName => ({
  type: RECEIVE_USERNAME,
  userName
});

export function doSignUp(email, password, name, mobile, newsletter, tnc) {
  return function(dispatch) {
    dispatch(signUp());
    Auth.signUp({
      username: email,
      password: password,
      attributes: {
        email: email,
        name,
        'custom:phone_number': '+60' + mobile,
        'custom:newsletter': newsletter ? '1' : '0'
        // 'custom:tnc': tnc ? '1' : '0'
      }
    })
      .then(data => {
        dispatch(completeSignUp(data));
      })
      .catch(err => {
        dispatch(receiveAuthError(err));
      });
  };
}

export function doConfirmSignUp(email, code) {
  return function(dispatch) {
    dispatch(confirmSignUp());
    Auth.confirmSignUp(email, code)
      .then(() => {
        dispatch(completeConfirmSignUp());
      })
      .catch(err => {
        dispatch(receiveAuthError(err));
      });
  };
}

export function doResendCode(email) {
  return function(dispatch) {
    dispatch(resendCode());
    return Auth.resendSignUp(email)
      .then(() => {
        dispatch(completeResendCode());
      })
      .catch(err => {
        dispatch(receiveAuthError(err));
      });
  };
}

export function doSignIn(email, password) {
  return function(dispatch) {
    dispatch(signIn());
    Auth.signIn({
      username: email,
      password: password
    })
      .then(user => {
        const cookies = new Cookies();
        var uri = cookies.get('sdacford_site_url');
        if (uri) {
          dispatch(redirect());
          cookies.remove('sdacford_site_url');
          window.location.replace(uri);
        } else {
          dispatch(completeSignIn(user));
          dispatch(fetchContestItems());
        }
      })
      .catch(err => {
        console.log(err);
        if (err.code === USER_NOT_CONFIRMED) {
          dispatch(setAuthEmail(email));
        }
        dispatch(receiveAuthError(err));
      });
  };
}

export function doSignOut() {
  return function(dispatch) {
    dispatch(signOut());
    const cookies = new Cookies();

    // If social logout from contest
    if (
      cookies.get('amplify-signin-with-hostedUI') === 'true' &&
      window.location.pathname === '/getaways/contest'
    ) {
      Auth.currentSession().then(data => {
        const sub = data.accessToken.payload.sub;
        const jwtToken = data.accessToken.jwtToken;
        const token = 'Bearer ' + btoa(jwtToken);
        const headers = {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': decodeURIComponent(cookies.get('XSRF-TOKEN')),
          'X-Sub': sub,
          'X-Auth': token,
          'X-Site': process.env.APP_URL_GETAWAYS
        };
        return api
          .delete('/v1/sso/web/logout', {
            headers: headers,
            data: {
              accessToken: jwtToken
            }
          })
          .then(res => {
            const cookies = new Cookies();
            const allCookies = cookies.getAll();
            Object.keys(allCookies).map(res => {
              console.log(res);
              cookies.remove(res, {
                path: '/',
                domain: '.' + process.env.DOMAIN_NAME || process.env.DOMAIN_NAME
              });
            });
            location.reload();
          })
          .catch(err => {
            console.log(err.response);
          });
      });
    } else {
      Auth.signOut()
        .then(() => {
          const cookies = new Cookies();
          const allCookies = cookies.getAll();
          Object.keys(allCookies).map(res => {
            console.log(res);
            cookies.remove(res, {
              path: '/',
              domain: '.' + process.env.DOMAIN_NAME || process.env.DOMAIN_NAME
            });
          });
          dispatch(completeSignOut());

          // Reset contest once logout
          dispatch(fetchContestItems());
          dispatch(setContestStep('voting'));
          dispatch(contestHasSubmitted(false));
        })
        .catch(err => {
          dispatch(receiveAuthError(err));
        });
    }
  };
}

export function doRequestPasswordReset(email) {
  return function(dispatch) {
    dispatch(requestPasswordReset());
    Auth.forgotPassword(email)
      .then(() => {
        dispatch(completeRequestPasswordReset());
      })
      .catch(err => {
        dispatch(receiveAuthError(err));
      });
  };
}

export function doSubmitForgotPassword(email, code, newPassword) {
  return function(dispatch) {
    dispatch(submitForgotPassword());
    Auth.forgotPasswordSubmit(email, code, newPassword)
      .then(() => {
        dispatch(completeSubmitForgotPassword());
      })
      .catch(err => {
        dispatch(receiveAuthError(err));
      });
  };
}

export function doChangePassword(oldPassword, newPassword) {
  return function(dispatch) {
    dispatch(changePassword());
    Auth.currentAuthenticatedUser()
      .then(user => {
        return Auth.changePassword(user, oldPassword, newPassword);
      })
      .then(() => {
        dispatch(completeChangePassword());
      })
      .catch(err => {
        if (err === 'not authenticated') {
          dispatch(completeSignOut());
        } else {
          dispatch(receiveAuthError(err));
        }
      });
  };
}

export function doCheckCurrentUser() {
  return function(dispatch) {
    dispatch(checkCurrentUser());
    Auth.currentAuthenticatedUser()
      .then(user => {
        dispatch(completeCheckCurrentUser(user));
      })
      .catch(err => {
        if (err === 'not authenticated') {
          dispatch(completeSignOut());
        } else {
          dispatch(receiveAuthError(err));
        }
      });
  };
}

export function generateSsoUrl(method, xcsrfToken) {
  return function() {
    const headers = {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': xcsrfToken
    };
    return api
      .post('/v1/sso/generate-url', { method: method }, { headers })
      .then(res => {
        window.location.replace(res.data.redirect_to);
      })
      .catch(err => {
        console.log(err.response);
        dispatch(receiveAuthError(err));
      });
  };
}

export function getUsername() {
  return function(dispatch) {
    return apiAuth('/v1/account/username')
      .then(res => {
        dispatch(receiveUsername(res.data.username));
      })
      .catch(err => {
        console.log(err);
        dispatch(receiveAuthError(err));
      });
  };
}
